import { FC } from 'react';

import { LoadingLayout } from 'components';
import { useNavigate, usePageTitle } from 'libs/navigation';
import { ErrorFallback } from 'modules/App/ErrorFallback';

import { useDirectory } from '../hooks/useDirectory';
import { DirectoryView } from '../views/DirectoryView';

export type DirectoryContainerProps = {};

export const DirectoryContainer: FC<DirectoryContainerProps> = () => {
  const { params } = useNavigate<{ schemaId: string }>();

  const {
    columns,
    title,
    values,
    loadingRecords,
    loadingSchemas,
    page,
    rowCount,
    limit,
    filter,
    notFound,
    setFilter,
    setRowHref,
    onArchiveRecord,
    onDearchiveRecord,
    onPaginationChange,
    onNavigateAddRecord,
  } = useDirectory(params.schemaId!);

  usePageTitle(title ?? '');

  if (notFound) {
    return <ErrorFallback />;
  }

  if (loadingSchemas) {
    return <LoadingLayout />;
  }

  return (
    <DirectoryView
      columns={columns}
      limit={limit}
      loading={loadingRecords}
      page={page}
      rowCount={rowCount}
      search={filter.search || ''}
      setRowHref={setRowHref}
      title={title ?? ''}
      values={values}
      onClickAdd={onNavigateAddRecord}
      onPaginationChange={onPaginationChange}
      onRecordArchive={onArchiveRecord}
      onRecordDearchive={onDearchiveRecord}
      onSearch={(search) => setFilter({ ...filter, search })}
    />
  );
};
